<!-- header start -->
<header class="sticky" [ngClass]="class" [class.fixed]="stick && sticky">
    <div class="mobile-fix-option"></div>
    <div class="top-header" *ngIf="topbar">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="header-contact">
                        <ul>
                            <li *ngIf="!isLoggedIn">Chào mừng đến với Foodify</li>
                            <li *ngIf="isLoggedIn">Chào mừng trở lại, {{ userFullName }}</li>
                            <li><i class="fa fa-phone" aria-hidden="true"></i>0917806496</li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-6 text-end">
                    <ul class="header-dropdown">
                        <li class="compare">
                            <!-- <a [routerLink]="['/home/aboutus']">
                                <i class="fa fa-paper-plane" aria-hidden="true"></i>About Us
                            </a> -->
                        </li>
                        <li class="mobile-wishlist">
                            <a [routerLink]="['/home/aboutus']">
                                <i class="fa fa-paper-plane" aria-hidden="true"></i>Thông tin về chúng tôi
                            </a>
                        </li>
                        <li class="onhover-dropdown mobile-account">
                            <a *ngIf="isLoggedIn" [routerLink]="['/home/dashboard']"><i class="fa fa-user"
                                    aria-hidden="true"></i>Tài khoản</a>
                            <a *ngIf="!isLoggedIn"><i class="fa fa-user" aria-hidden="true"></i>Tài khoản</a>
                            <ul class="onhover-show-div">
                                <li *ngIf="!isLoggedIn">
                                    <a data-lng="en" [routerLink]="['/home/login']">
                                        Đăng nhập
                                    </a>
                                </li>
                                <li *ngIf="!isLoggedIn">
                                    <a data-lng="en" [routerLink]="['/home/register']">
                                        Đăng ký
                                    </a>
                                </li>
                                <li *ngIf="isLoggedIn">
                                    <a data-lng="es" (click)="logOut()">
                                        Đăng xuất
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="main-menu border-section border-top-0">
                    <div class="brand-logo layout2-logo headerlogo">
                        <a [routerLink]="['/home']">
                            <img [src]="themeLogo" class="img-fluid" alt="logo">
                        </a>
                    </div>
                    <div class="menu-right pull-right">
                        <app-settings></app-settings>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>
<!-- header end -->